/**
 * @module components\ghInput\dateInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";

@Component
export default class DateInput extends InputBase {
  // private get Value() {
  //   try {
  //     if (this.value) {
  //       let d = new Date(this.value);
  //       d.setHours(d.getHours() + 8);
  //       return d.toISOString().substr(0, 10);
  //     }
  //   } catch (error) {
  //     return "";
  //   }
  // }

  // private get on() {
  //   return Object.assign({}, this.inputListeners, {
  //     change: e => {
  //       this.$emit("input", e);
  //     }
  //   });
  // }
}
